__turbopack_context__.v({
  "container": "NotOnboardedMessage-module-scss-module__kmmR8G__container",
  "imageContainer": "NotOnboardedMessage-module-scss-module__kmmR8G__imageContainer",
});
